import { Component, OnInit, Inject } from '@angular/core';

import { Router } from '@angular/router';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { TextosService } from '../../services/textos/textos.service';
import Swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { Tipos } from 'src/app/models/tipos/tipos.model';
import { isNullOrUndefined } from 'util';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { environment } from '../../../environments/environment';



declare const Rut: any;
declare const ageCalculator: any;
@Component({
  selector: 'app-convenio-jub',
  templateUrl: '../../pages/convenio/convenio-solicitar.html',
  styleUrls: ['../../pages/convenio/convenio.component.css']
})

export class ConvenioJubComponent implements OnInit {

  element: any = true
  cantidadArchivos: any = 1
  postulaciones: any
  categorias: any
  proveedores: any
  cuotas: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  tipoPostulacion: string = "Disponibles"
  allComplete: boolean = false
  regiones: any
  estado: any
  nombreUsuario: any
  rutUsuario: any
  totalMaximo: any
  topeMaximoSolicitado: any
  textos: any
  linkTexto: any
  visible: any
  montoTotalCalculado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  codeudor: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  codeudor2: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  beneficiario: any = { rutBeneficiario: '', idBeneficiario: '', nombreBeneficiario: '', apellidoBeneficiario: '' };
  postulantes: Usuario[]
  buscador: any =
    {
      rut: '', rut2: '', rutAfiliado: '', idRegion: '0', categoriaConvenio: '0',
      proveedor: '0', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA']
    }

  convenio: any = {
    montoSolicitado: '', idCantidadCuota: '0', idProveedor: '0',
    idRegion: '0', idTipoConvenio: '0', archivo: [], totalReal: '', numPresupuesto: '',
    archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, planes: [], capacidadDescuento: ''
  }
  constructor(public router: Router, public convenioService: ConvenioService, public productosService: ProductosService,
    private dialog: MatDialog,
    private afiliacionService: AfiliacionService, 
    private tiposService: TiposService,private textosService: TextosService) {

  }

  ngOnInit() {
    let vm = this
    this.nombreUsuario = localStorage.getItem("nombreUsuario");
    this.rutUsuario = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
    this.totalMaximo = 0;

    this.textosService.obtieneTextos()
    .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "CONVENIO")?.valor;             
    })
    .catch(error => {
        console.error('Error al obtener los textos:', error);
    });


    this.convenioService.traeRegionesEspeciales().then(regiones => this.regiones = regiones).catch(error => console.log(error));
    this.convenioService.traeCategoriaConvenio().then(response => this.categorias = response
    ).catch(error => console.log(error))

    this.productosService.obtieneProductos().then
      (
        productos => productos[3].parametros.map(parametro => {
          if (parametro.descripcion == 'TOPE_MAXIMO_SOLICITADO') {
            this.topeMaximoSolicitado = parametro.valor
          }
        })
      )
      .catch(error => console.log(error))


    this.visible = false;

    if (this.rol == 'ROLE_AFILIADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;

      this.afiliado.rutAfiliado = this.rutUsuario;

      this.afiliado.idAfiliado = this.idEjecutivo;

      this.convenioService.traeMontoTotalDisponible(this.afiliado.idAfiliado).then(
        response => {
          this.totalMaximo = response;
          this.convenio.montoSolicitado = response;
        }
      ).catch(error => {
        console.log(error);
        this.totalMaximo = 0;
      });


      this.convenioService.traeCapacidadDescuento(this.afiliado.idAfiliado).then(
        response => {

          this.convenio.capacidadDescuento = response;
        }
      ).catch(error => {
        console.log(error);

      });

      this.buscaCodeudor(this.rutUsuario, 3);

      this.afiliacionService.traeSoloAfiliadoSinEstados(this.rutUsuario.split('-')[0]).then
      (
        (response: any) => {
          if(response.estadoAfiliado  && response.estadoAfiliado =='PENDIENTE_DESAFILIACION'){
            this.openAlertDialog('Usted se encuentra pendiente de desafiliación por lo que no puede postular a este beneficio.', 'btn-danger')
            this.router.navigate(['/index'])                 
          }
        }
      )
      .catch
      (
          error => {
            console.log(error);
          }
      )

    }
  }

  habilitaDental(idTipoConvenio: any) {
    // Revisar bien dónde llamo a agregar el reembolso del convenio dental, no es a1uí
    if (idTipoConvenio == '24') {

      this.visible = true

    } else {

      this.visible = false
    }
  }
  buscarCantidadCuotas() {
    this.convenioService.traeCantidadCuotasProveedor(this.convenio.idProveedor).
      then(cuota => this.cuotas = cuota).catch(error => console.log(error))
  }

  buscaProveedor() {

    let region = this.convenio.idRegion;
    let categoria = this.convenio.idTipoConvenio;
    if (region == '0' || categoria == '0') {
      this.openAlertDialog('Debe seleccionar región y categoría', 'btn-danger')
    }
    else {
      this.convenioService.traeProveedoresPorRegionyTipo(region, categoria).then
        (response => { this.proveedores = response }).catch(error => {
          console.log(error);

        });
    }
  }

  buscaCodeudor(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {     
      let rut = rutABuscar.split('.').join('').split('-')[0]
      this.traePostulantes(rut, ubicacion)
    }
    else {
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
    }
  }
  

  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.convenio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.convenio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

        console.log(vm.convenio.archivo)
      }
    }
  }

  sumaArchivo() {
    if (this.cantidadArchivos <= 5) {

      this.cantidadArchivos = this.cantidadArchivos + 1
    }
  }

  restaArchivo() {
    this.cantidadArchivos = this.cantidadArchivos - 1
    this.convenio.archivo.splice(this.cantidadArchivos, 1);


  }
  calcularPlanPago() {
    this.element = true;
    let vm = this
    let error = 0;
    vm.montoTotalCalculado = vm.convenio.montoSolicitado;
    let Cantidadcuotas = 10;
    if (this.convenio.capacidadDescuento == 0) {
      this.openAlertDialog('El usuario no puede simular un plan de pago para un convenio pues no tiene capacidad de descuento.', 'btn-danger')
      Swal.close();
      error = 1;
    }

    if (this.convenio.montoSolicitado > this.totalMaximo) {
      vm.openAlertDialog('Monto solicitado excede el total máximo que se puede solicitar.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    if (this.convenio.numPresupuesto == "") {
      vm.openAlertDialog('Debe digitar un número de presupuesto.', 'btn-danger')
      Swal.close();
      error = 1;
    }

    if (this.convenio.idCantidadCuota == 0) {
      vm.openAlertDialog('Debe Seleccionar la cantidad de cuotas.', 'btn-danger')
      Swal.close();
      error = 1;
    }

    if (this.postulantes[this.beneficiario] == undefined && this.convenio.idTipoConvenio == 24) {
      vm.openAlertDialog('Debe Seleccionar un beneficiario.', 'btn-danger')
      Swal.close();
      error = 1;
    }

    if (this.convenio.archivoTest == null) {
      this.openAlertDialog('No puede solicitar un convenio sin haber seleccionado un archivo.', 'btn-danger')
      Swal.close();
      error = 1;
    }

    /* if(vm.convenio.totalReal > vm.totalMaximo || vm.convenio.totalReal == 0 ){
         vm.openAlertDialog('El monto solicitado excede el valor real de endeudamiento.', 'btn-danger')
         Swal.close();
         error = 1;
     }*/
    if (error == 0) {
      vm.convenioService.calcularPlanPagoConvenio(vm.convenio.montoSolicitado, vm.convenio.idCantidadCuota).
        then(
          (planes: any) => {

            if (planes.length)
              Cantidadcuotas = planes.length

            if ((vm.convenio.capacidadDescuento * Cantidadcuotas) < this.convenio.montoSolicitado) {
              vm.openAlertDialog('Monto solicitado excede capacidad de descuento.', 'btn-danger')
              Swal.close();
              error = 1;
            } else {
              vm.convenio.planes = planes
              vm.config.currentPage = 1
              vm.config.totalItems = planes.length
            }
          }
        )
        .catch(error => {
          console.log(error)
          Swal.close();
          this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-dark')
        })
    }

  }
  limpiarCodeudores() {
    console.log("limpiar codeudores");
    let vm = this;

    vm.codeudor.rutCodeudor = ''
    vm.codeudor.idCodeudor = ''
    vm.codeudor.nombreCodeudor = ''
    vm.codeudor.apellidoCodeudor = ''
    vm.codeudor.rutCodeudor = ''
    vm.codeudor2.rutCodeudor = ''
    vm.codeudor2.idCodeudor = ''
    vm.codeudor2.nombreCodeudor = ''
    vm.codeudor2.apellidoCodeudor = ''
    vm.codeudor2.rutCodeudor = ''
    vm.buscador.rut = ''
    vm.buscador.rut2 = ''
  }

  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO' && ubicacion==3){  
      this.validarEstado(rut.split('.').join('').split('-')[0])
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.convenioService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {
          if (ubicacion == 1) {
            if (usuario.tipoAfiliado == 'PASIVO') {
              this.openAlertDialog('El codeudor es del tipo PASIVO.', 'btn-danger')
              Swal.close();
              return false
            }
            if (usuario.estadoAfiliado == 'DESAFILIADO') {
              this.openAlertDialog('El codeudor se encuentra DESAFILIADO.', 'btn-danger')
              Swal.close();
              return false
            }
            vm.codeudor.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor.idCodeudor = usuario.id
          }
          if (ubicacion == 2) {
            if (usuario.tipoAfiliado == 'PASIVO') {
              this.openAlertDialog('El codeudor es del tipo PASIVO.', 'btn-danger')
              Swal.close();
              return false
            }
            if (usuario.estadoAfiliado == 'DESAFILIADO') {
              this.openAlertDialog('El codeudor se encuentra DESAFILIADO.', 'btn-danger')
              Swal.close();
              return false
            }
            vm.codeudor2.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor2.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor2.idCodeudor = usuario.id
          }
          if (ubicacion == 3) {

            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
            vm.afiliado.idAfiliado = usuario.id


            this.convenioService.traeMontoTotalDisponible(this.afiliado.idAfiliado).then(
              response => {
                this.totalMaximo = response;
                this.convenio.montoSolicitado = response;
              }
            ).catch(error => {
              console.log(error);
              this.totalMaximo = 0;
            });


            this.convenioService.traeCapacidadDescuento(this.afiliado.idAfiliado).then(
              (response: any) => {

                this.convenio.capacidadDescuento = response;
              }
            ).catch(error => {
              console.log(error);

            });

            let usuariosPostulantes: Array<Usuario> = []

            usuariosPostulantes.push({
              id: usuario.id, nombres: usuario.nombres,
              apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
              fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
              dv: usuario.dv, parentesco: 'TITULAR', fechaAfiliacion: usuario.fechaAfiliacion
            })

            usuario.carga ? usuario.carga.forEach(carga => {
              carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)
              carga.fechaAfiliacion = carga.fechaCreacion

              usuariosPostulantes.push(carga)
            }) : null;
            vm.postulantes = usuariosPostulantes
          }

          this.habilitaDental(this.convenio.idTipoConvenio);
          Swal.close();

        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-success')
      })
  }

    validarEstado(rutAfiliado){
      this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
      ( 
          (response: any) => {
              if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                  || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                      || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                          console.log(response.estadoAfiliado)
                  this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                  this.router.navigate(['/index'])                 
              }
          }
      )
      .catch
      (
          error => {
          console.log('error :',error);
          }
      ) 
    }

  solicitar(form: NgForm) {

    let idAfiliado = this.afiliado.idAfiliado
    let error = 0

    this.element = false; 
    if (this.convenio.capacidadDescuento == 0) {
      this.openAlertDialog('El usuario no puede solicitar un convenio sin tener capacidad de descuento.', 'btn-danger')
      Swal.close();
      error = 1
    }
    if ((this.convenio.capacidadDescuento * 10) < this.convenio.montoSolicitado) {
      this.openAlertDialog('Monto solicitado excede capacidad de descuento.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    if (this.convenio.archivoTest == null) {
      this.openAlertDialog('No puede solicitar un convenio sin haber seleccionado un archivo.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    if (this.convenio.montoSolicitado > this.totalMaximo) {
      this.openAlertDialog('Monto solicitado excede el total máximo que se puede solicitar.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    if (error == 1) {
      this.element = true;
    }

    if (error == 0) {
      let usuarioId = localStorage.getItem("idUsuario");
      let cargaId: any, titular: any;
      if (this.visible == true) {
        let usuarioSeleccionado = this.postulantes[this.beneficiario]
        let usuarioTitular = usuarioSeleccionado
        this.postulantes.forEach(postulante => {
          if (postulante.parentesco == 'TITULAR') {
            usuarioTitular = postulante
          }

        })


        if (this.convenio.idTipoConvenio == '24') {

          if (usuarioSeleccionado.parentesco != 'TITULAR') {

            cargaId = usuarioSeleccionado.id
          }

        }

      }
      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de Ingresar la Solicitud de Convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.element = false; 
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();
          ;


          let sizeArchivos = 0;
          for (let i = 0; i < this.cantidadArchivos; i++) {
            if (!this.convenio.archivo[i]) {
              this.openAlertDialog('Debe volver a adjuntar el presupuesto y presionar el botón Calcular.', 'btn-danger')
              Swal.close();
              error = 1;
              this.element = true; 
            }
            sizeArchivos += this.convenio.archivo[i].size;
            if (sizeArchivos > 25000000) {
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();

              this.element = true;
              return;
            }
            this.convenio.archivo[i].sizeArchivos
            if (this.convenio.archivo[i].extension != "application/pdf" && this.convenio.archivo[i].extension != "image/jpeg" &&
              this.convenio.archivo[i].extension != "image/jpg" && this.convenio.archivo[i].extension != "image/png") {
              this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')

              Swal.close();

              this.element = true; 
              return false
            }
            let vm = this;

            this.convenioService.ingresarConvenio(usuarioId, idAfiliado, this.convenio, cargaId,
              this.codeudor, this.codeudor2, this.convenio.planes).then(
                () => {
                  Swal.close();
                  this.convenio.archivo = [];
                  this.openAlertDialog('La solicitud de Convenio fue ingresada exitosamente.', 'btn-success')
                  form.reset()
                  this.reloadComponent();
                  this.element = true; 
                }
              )
              .catch
              (error => {
                if (error.status == 406) {
                  this.openAlertDialog('Los Codeudores deben ser distintos y también diferentes al solicitante.', 'btn-danger')
                  this.element = true; 
                }

                if (error.status == 403) {
                  this.openAlertDialog('Debe seleccionar una región.', 'btn-danger')
                  this.element = true; 

                }
                if (error.status == 410) {
                  this.openAlertDialog('Ambos codeudores no están autorizados a serlo.', 'btn-danger')
                  this.element = true; 
                  Swal.close();
                }
                if (error.status == 428) {
                  this.openAlertDialog('Debe ingresar un número de presupuesto.', 'btn-danger')
                  this.element = true; 
                  Swal.close();
                }
                if (error.status == 409) {
                  this.openAlertDialog('El codeudor 1 no puede serlo.', 'btn-danger')
                  this.element = true; 
                  Swal.close();
                }
                if (error.status == 418) {
                  this.openAlertDialog('El codeudor 2 no puede serlo.', 'btn-danger')
                  this.element = true; 
                  Swal.close();
                }
                if (error.status == 411) {
                  this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda.', 'btn-danger')
                  this.element = true; 
                }
                if (error.status == 417) {
                  this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
                  this.element = true; 

                }
                if (error.status == 422) {
                  this.openAlertDialog('Debe seleccionar un tipo de Convenio.', 'btn-danger')
                  this.element = true; 

                }
                if (error.status == 424) {
                  this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
                  this.element = true; 
                }
                if (error.status == 412) {
                  this.openAlertDialog('Los Codeudores no están autorizados pues tienen más de 2 solicitudes como codeudor.', 'btn-danger')
                  this.element = true; 

                }
                /*
                if (error.status == 402) {
                  this.openAlertDialog('El Usuario no cumple la carencia mínima para poder postular.', 'btn-danger')
                  this.element = true; 
                }*/

                if (error.status == 402) {
                  this.openAlertDialog('No debe tener más de un convenio pendiente con el mismo proveedor.', 'btn-danger')
                  this.element = true; 
                }

                this.convenio.archivo = [];
                Swal.close();

                this.element = true; 
                if (error.status == 500) {
                  this.openAlertDialog('No se pudo ingresar la solicitud de Convenio, ya existe una solicitud Pendiente.', 'btn-danger')
                  this.element = true; 
                }
              }
              )
          }

        }else{
          this.element = true; 
        }

      })
    }
  }

  sumarReembolso(i: any) {

    let usuarioSeleccionado = this.postulantes[i]

    let titular = usuarioSeleccionado.parentesco;
    let categoria = 14;
    let tope = 500000;
    let esTitular = true;
    if (titular != 'TITULAR') {
      esTitular = false;
      categoria = 15;
    }

    let id = usuarioSeleccionado.id
    this.convenioService.sumarReembolso(id, esTitular, categoria).then(
      response => {

        if (this.topeMaximoSolicitado)
          tope = this.topeMaximoSolicitado

        if (this.convenio.montoSolicitado > tope) {
          alert("El monto solicitado no debe superar el tope de " + this.convenio.montoSolicitado);
          return;
        }/* else {
          this.totalMaximo += response;
          alert("El monto máximo a pedir es " + this.totalMaximo);
        }*/

      }
    ).catch(error => {
      console.log(error);

    });
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  salir() { this.router.navigate(['/index']) }


}


